import React, {Component} from 'react';
import LessonTest from "./LessonTest";
import Menu from "../Menu";
import PageHeader from "../PageHeader";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import Comments from "./Comments";

type LessonState = {
    lesson: any | null,
    attempts: any[],
    isLoading: boolean,
    error: string,
};

export class Lesson extends Component<any, LessonState> {
    constructor(props: any) {
        super(props);
        this.state = {
            lesson: null,
            attempts: [],
            isLoading: true,
            error: '',
        };
    }

    componentDidMount() {
        this.loadLesson();
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.idLesson !== this.props.idLesson) {
            this.loadLesson();
        }
    }

    loadLesson() {
        window.scrollTo(0, 0);
        this.setState({
            lesson: null,
            attempts: [],
            isLoading: true,
            error: '',
        });

        const lessonUrl = GlobalVariable.staffBack() + '/getLesson/' + this.props.idLesson;
        const attemptsUrl = GlobalVariable.staffBack() + '/api/lesson/' + this.props.idLesson + '/test-attempts';
        const viewUrl = GlobalVariable.staffBack() + '/api/lesson/' + this.props.idLesson + '/view';

        api({
            url: lessonUrl,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: {},
            withCredentials: true,
        })
            .then((result) => {
                this.setState({
                    lesson: result.data,
                    isLoading: false,
                    error: '',
                });

                api({
                    url: viewUrl,
                    headers: {'Content-Type': 'application/json'},
                    method: "post",
                    data: {},
                    withCredentials: true,
                }).catch(() => {});
            })
            .catch(() => {
                this.setState({
                    lesson: null,
                    isLoading: false,
                    error: 'Не удалось загрузить урок.',
                });
            });

        api({
            url: attemptsUrl,
            headers: {'Content-Type': 'application/json'},
            method: "get",
            withCredentials: true,
        })
            .then((result) => {
                this.setState({attempts: result.data});
            })
            .catch(() => {});
    }

    convertIframeToVideo(html: string) {
        if (!html) return html;

        return html.replace(
            /<iframe[^>]+src="([^"]+\.mp4)"[^>]*><\/iframe>/g,
            (match, src) => `
            <video class="ql-video" controls playsInline preload="metadata" style="max-width:100%">
                <source src="${src}" type="video/mp4" />
                Ваш браузер не поддерживает видео.
            </video>
        `
        );
    }

    render() {
        const {lesson, attempts, isLoading, error} = this.state;
        const backBtnUrl = lesson && lesson.categoryId
            ? '/knowledge-base/' + lesson.categoryId
            : '/knowledge-base/' + this.props.idCategory;

        return (
            <div className='main lesson'>
                <div className='content mx-w-content'>
                    <PageHeader
                        pageTitle='Урок'
                        backBtnUrl={backBtnUrl}/>
                    <div className='pt-header'></div>

                    <div className='pl-3 pr-3'>
                        {isLoading && <div className='chio-card mb-3 p-3'>Загрузка урока...</div>}
                        {!isLoading && error && <div className='chio-card mb-3 p-3 text-danger'>{error}</div>}
                        {!isLoading && !error && lesson && (
                            <>
                                <div className='chio-card-subheader bg-red pl-3 pr-3 pt-2 d-flex justify-content-between '>
                                    <span className='text-white txt-middle'></span>
                                    <span className='text-white txt-middle'>
                                        <img className='ico mr-2' src='/img/knowledge-base/ico-clock-white.svg' alt=''/>
                                        {lesson.time}
                                    </span>
                                </div>
                                <div className='chio-card mb-2 p-3 mb-3'>
                                    <div className='txt-large'>{lesson.title}</div>
                                </div>
                                <div
                                    className="content"
                                    dangerouslySetInnerHTML={{
                                        __html: this.convertIframeToVideo(lesson.content)
                                    }}
                                ></div>

                                {attempts && attempts.length > 0 && (
                                    <div className="chio-card mb-3 p-3">
                                        <div className="txt-large mb-2">Ваши попытки</div>
                                        <table className="table">
                                            <thead>
                                            <tr>
                                                <th>Дата</th>
                                                <th>Результат</th>
                                                <th>Статус</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {attempts.map((attempt) =>
                                                <tr key={attempt.attemptId}>
                                                    <td>{attempt.startedAt}</td>
                                                    <td>
                                                        {attempt.isFinished
                                                            ? `${attempt.correctCount} из ${attempt.answersCount}`
                                                            : '—'}
                                                    </td>
                                                    <td>
                                                        {attempt.isFinished
                                                            ? <span className="text-success">Завершён</span>
                                                            : <span className="text-warning">В процессе</span>
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                <div>
                                    {lesson.questions && lesson.questions.length > 0 &&
                                        <LessonTest
                                            lessonId={this.props.idLesson}
                                            questions={lesson.questions}
                                        />
                                    }
                                    <Comments lessonId={this.props.idLesson}/>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <Menu/>
            </div>
        )
    }
}

export default Lesson;
